import {
    CREATE_PARTY_DETAILS_REQUEST,
    CREATE_PARTY_DETAILS_SUCCESS,
    CREATE_PARTY_DETAILS_FAILURE,
    DELETE_PARTY_DETAILS_REQUEST,
    DELETE_PARTY_DETAILS_SUCCESS,
    DELETE_PARTY_DETAILS_FAILURE,
    FETCH_SINGLE_PARTY_DETAILS_REQUEST,
    FETCH_SINGLE_PARTY_DETAILS_SUCCESS,
    FETCH_SINGLE_PARTY_DETAILS_FAILURE,
    FETCH_PARTY_DETAILS_REQUEST,
    FETCH_PARTY_DETAILS_SUCCESS,
    FETCH_PARTY_DETAILS_FAILURE,
    UPDATE_PARTY_DETAILS_REQUEST,
    UPDATE_PARTY_DETAILS_SUCCESS,
    UPDATE_PARTY_DETAILS_FAILURE,
    RESET_PARTY_DETAILS_INFO,
    CREATE_PARTY_DETAILS_FORM,
    UPDATE_PARTY_DETAILS_FORM,
    FETCH_PARTY_DETAILS_WITHOUT_ID_SUCCESS,
    RESET_PARTY_DETAILS,
    FETCH_PARTY_DETAILS_PAN_FILE_REQUEST,
    FETCH_PARTY_DETAILS_GST_FILE_REQUEST,
    FETCH_PARTY_DETAILS_GST_FILE_SUCCESS,
    FETCH_PARTY_DETAILS_PAN_FILE_SUCCESS,
    SET_PAN_FILE_NAME_PARTY_DETAILS,
    SET_GST_FILE_NAME_PARTY_DETAILS,
    FETCH_PARTY_DETAILS_PAN_FILE_FAILURE,
    FETCH_PARTY_DETAILS_GST_FILE_FAILURE
} from './partyDetails.actionsType';

export const PARTY_DETAILS = 'partyDetails';

let initialState = {
    loading: false,
    panFileName: '',
    gstFileName: '',
    partyDetails: [],
    partyDetailsWithoutId: [],
    partyDetailsform: {
        fldUnitType: [],
        panFileName: '',
        gstFileName: ''
    },
    selectedState: {},
    errorMessage: ''
};

export let partyDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PARTY_DETAILS_REQUEST:
        case FETCH_PARTY_DETAILS_PAN_FILE_REQUEST:
        case FETCH_PARTY_DETAILS_GST_FILE_REQUEST:
        case CREATE_PARTY_DETAILS_REQUEST:
        case UPDATE_PARTY_DETAILS_REQUEST:
        case FETCH_SINGLE_PARTY_DETAILS_REQUEST:
        case DELETE_PARTY_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PARTY_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                partyDetails: updatePayload
            };
        case FETCH_PARTY_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                partyDetailsWithoutId: updatePayload
            };
        case FETCH_PARTY_DETAILS_PAN_FILE_SUCCESS:
            var imageId = `data:image/png;base64,${updatePayload}`;
            var arr = imageId.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return {
                ...state,
                loading: false,
                panFileName: `data:image/png;base64,${updatePayload}`,
                partyDetailsform: {
                    ...state.partyDetailsform,
                    fldPANFile: updatePayload
                        ? new File([u8arr], `${state?.partyDetailsform?.fldPANFileName}.png`, { type: `image/png` })
                        : ''
                }
            };
        case FETCH_PARTY_DETAILS_GST_FILE_SUCCESS:
            var imageId = `data:image/png;base64,${updatePayload}`;
            var arr = imageId.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return {
                ...state,
                loading: false,
                gstFileName: `data:image/png;base64,${updatePayload}`,
                partyDetailsform: {
                    ...state.partyDetailsform,
                    fldGSTFile: updatePayload
                        ? new File([u8arr], `${state?.partyDetailsform?.fldGSTFileName}.png`, { type: `image/png` })
                        : ''
                }
            };
        case CREATE_PARTY_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                partyDetailsform: {
                    fldUnitType: []
                }
            };
        case UPDATE_PARTY_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                partyDetailsform: {
                    fldUnitType: []
                }
            };
        case SET_PAN_FILE_NAME_PARTY_DETAILS:
            return {
                ...state,
                loading: false,
                panFileName: payload
            };
        case SET_GST_FILE_NAME_PARTY_DETAILS:
            return {
                ...state,
                loading: false,
                gstFileName: payload
            };
        case FETCH_SINGLE_PARTY_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                partyDetailsform: updatePayload
            };
        case DELETE_PARTY_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                partyDetailsform: {
                    fldUnitType: []
                }
            };
        case RESET_PARTY_DETAILS_INFO:
            return {
                ...state,
                partyDetailsform: {
                    fldUnitType: [],
                    panFileName: '',
                    gstFileName: ''
                }
            };
        case CREATE_PARTY_DETAILS_FORM:
        case UPDATE_PARTY_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                partyDetailsform: {
                    ...state.partyDetailsform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PARTY_DETAILS_FAILURE:
        case FETCH_PARTY_DETAILS_PAN_FILE_FAILURE:
        case FETCH_PARTY_DETAILS_GST_FILE_FAILURE:
        case CREATE_PARTY_DETAILS_FAILURE:
        case UPDATE_PARTY_DETAILS_FAILURE:
        case FETCH_SINGLE_PARTY_DETAILS_FAILURE:
        case DELETE_PARTY_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };

        case RESET_PARTY_DETAILS:
            return {
                loading: false,
                partyDetails: [],
                partyDetailsWithoutId: [],
                partyDetailsform: {
                    fldUnitType: [],
                    panFileName: '',
                    gstFileName: ''
                },
                selectedState: {},
                errorMessage: ''
            };
        default:
            return state;
    }
};
